import { css } from 'styled-components';

const marginStyles = (margin) => {
    if (!margin)
        return css `
      margin: 0;
    `;
    if (typeof margin === 'string')
        return css `
      margin: ${margin};
    `;
    return css `
    margin-top: ${margin === null || margin === void 0 ? void 0 : margin.top};
    margin-right: ${margin === null || margin === void 0 ? void 0 : margin.right};
    margin-bottom: ${margin === null || margin === void 0 ? void 0 : margin.bottom};
    margin-left: ${margin === null || margin === void 0 ? void 0 : margin.left};
  `;
};
const paddingStyles = (padding) => typeof padding === 'string'
    ? css `
        padding: ${padding};
      `
    : css `
        padding-top: ${padding === null || padding === void 0 ? void 0 : padding.top};
        padding-right: ${padding === null || padding === void 0 ? void 0 : padding.right};
        padding-bottom: ${padding === null || padding === void 0 ? void 0 : padding.bottom};
        padding-left: ${padding === null || padding === void 0 ? void 0 : padding.left};
      `;
const ctaStyles = (props) => css `
  border-radius: ${props.theme.borderRadii.large};
  font-family: ${props.theme.fontFamilies.main.medium};
  cursor: pointer;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props.theme.fontSizes[500]};
  line-height: ${props.theme.lineHeights.small};
  padding: ${props.size === 'small' ? '7px 16px' : '15px 16px'};
  text-align: center;
  text-decoration: none;
  transition: ${props.theme.transitionDurations.default};
  width: ${props.fullWidth && '100%'};
  white-space: ${props.whiteSpace ? props.whiteSpace : 'normal'};
  -webkit-font-smoothing: antialiased;

  ${marginStyles(props.margin)};
`;
const disabled = (props) => css `
  cursor: not-allowed;
  opacity: ${props.theme.opacities.low};
`;
const formElementErrorStyles = (props) => !!props.error &&
    !props.disabled &&
    css `
    background-color: ${props.theme.colors.background.error};
    border: 1px solid ${props.theme.colors.content.errorBright};
  `;
const formElementFocusStyles = (props) => css `
  outline: transparent solid 2px;
  border: 1px solid ${props.theme.colors.background.primaryInverse};
  box-shadow: 0 0 0 1px ${props.theme.colors.background.primaryInverse};
`;

export { ctaStyles, disabled, formElementErrorStyles, formElementFocusStyles, marginStyles, paddingStyles };
